const makerjs = require('makerjs')

import { layerNames } from '@/js/cad/CadLayerNaming.js'

export default class Baton {
  constructor(spiceRack, materialThickness, batonInfo) {
    this.models = {}

    this.spiceRack = spiceRack
    this.materialThickness = materialThickness
    this.batonInfo = batonInfo

    this.tSlotDepth = batonInfo?.tSlotDepth
    this.batonHeight = batonInfo?.batonHeight
    this.batonRebateToolDiameter = batonInfo?.batonRebateToolDiameter
    this.batonRebateInset = batonInfo?.batonRebateInset
    this.batonDrillGuideDiameter = batonInfo?.batonDrillGuideDiameter
    this.batonToWallDrillInset = batonInfo?.batonToWallDrillInset
    this.batonToShelfDrillInset = batonInfo?.batonToShelfDrillInset

    // CALCS
    this.batonLength = spiceRack.w - (materialThickness - this.tSlotDepth) * 2
    this.numBatons = spiceRack.shelves
    this.numOfBatonPosGaps = this.numBatons - 1
    this.frameRebateHeight =
      this.batonHeight * this.numBatons + this.numOfBatonPosGaps * 13 + this.batonRebateToolDiameter
    this.frameRebateWidth = this.tSlotDepth + this.batonRebateToolDiameter / 2

    for (let i = 0; i < this.numBatons; i++) {
      this.createBaton(i + 1)
    }
    this.createFrameRebate()
  }

  createBaton(copy) {
    let baton = (this.models['baton' + copy] = { models: {} })

    // Create baton cutout
    baton.models.baton = new makerjs.models.Rectangle(this.batonLength, this.batonHeight)
    baton.models.baton.layer = layerNames.cutout.label

    // create baton rebate
    baton.models.batonRebate = new makerjs.models.Rectangle(
      this.batonLength + this.batonRebateToolDiameter,
      this.batonRebateInset + this.batonRebateToolDiameter / 2
    )
    baton.models.batonRebate.layer = layerNames.spiceRackBatonRebate.label
    makerjs.model.move(baton.models.batonRebate, [-this.batonRebateToolDiameter / 2, -this.batonRebateToolDiameter / 2])

    // Create Drill Guides
    const drillGuide = new makerjs.models.Ellipse(this.batonDrillGuideDiameter / 2, this.batonDrillGuideDiameter / 2)
    drillGuide.layer = layerNames.spiceRackBatonDrillGuide.label

    // baton to shelf drill guide x 1
    baton.models.batonToShelfDrillGuide = makerjs.cloneObject(drillGuide)
    makerjs.model.move(baton.models.batonToShelfDrillGuide, [this.batonLength / 2, this.batonRebateInset / 2])

    // baton to frame drill guide x 2
    baton.models.batonToFrameDrillGuidePair = makerjs.layout.cloneToRow(
      drillGuide,
      2,
      this.batonLength - this.tSlotDepth - this.batonDrillGuideDiameter
    )
    makerjs.model.move(baton.models.batonToFrameDrillGuidePair, [this.tSlotDepth / 2, this.batonHeight / 2])

    // baton to wall drill guide x 2
    baton.models.batonToWallDrillGuidePair = makerjs.layout.cloneToRow(
      drillGuide,
      2,
      this.batonLength - this.tSlotDepth * 2 - this.batonToWallDrillInset * 2 - this.batonDrillGuideDiameter
    )
    makerjs.model.move(baton.models.batonToWallDrillGuidePair, [
      this.tSlotDepth + this.batonToWallDrillInset,
      this.batonHeight - (this.batonHeight - this.batonRebateInset) / 2
    ])

    // position baton one ontop of the other
    makerjs.model.move(baton, [0, (this.batonHeight + 13) * (copy - 1)])
  }

  createFrameRebate() {
    // separate because it wraps around all batons
    const frameRebate = new makerjs.models.Rectangle(this.frameRebateWidth, this.frameRebateHeight)
    frameRebate.layer = layerNames.spiceRackBatonRebate.label
    this.models.frameRebate = makerjs.layout.cloneToRow(frameRebate, 2, this.batonLength - this.tSlotDepth * 2)
    makerjs.model.move(this.models.frameRebate, [-this.batonRebateToolDiameter / 2, -this.batonRebateToolDiameter / 2])
  }
}
